import { axiosInstance as request } from '@/api/rest.service'

export const getTableCols = () => request.get('/publications/create')
export const getPublications = (id, params) => request.get(`/title-lists/${id}/publications?paginated=true`, { params })
export const updatePublication = (id, payload) => request.put(`/publications/${id}`, payload)
export const createPublication = (id, payload) => request.post(`/title-lists/${id}/publications`, payload)
export const deletePublication = id => request.delete(`/publications/${id}`)
